import { UserGuideGroupSkillLevel } from "types/generated";

export const formatSkillLevel = (level?: UserGuideGroupSkillLevel) => {
  if (!level) return undefined;
  // Convert "BEGINNER" to "Beginner"
  return level.charAt(0) + level.slice(1).toLowerCase();
};
